/*! Copyright (c) Safe As Milk. All rights reserved. */
class ProductSingle extends HTMLElement {
    #variant;
    connectedCallback() {
        this.mediaGallery = this.querySelector("media-gallery");
        this.#moveModalsFromStickyScrollContainer();
    }
    updateMedia() {
        if (!this.mediaGallery || !this.#variant.featured_media) return;
        const mediaId = this.#variant.featured_media.id;
        this.mediaGallery.goToSlide(mediaId);
    }
    set variant(variant) {
        this.#variant = variant;
        this.updateMedia();
    }
    get variant() {
        return this.#variant;
    }
    #moveModalsFromStickyScrollContainer() {
        const modals = this.querySelectorAll("sticky-scroll modal-dialog, sticky-scroll popup-dialog");
        modals.forEach((modal => {
            this.append(modal);
        }));
    }
}

customElements.define("product-single", ProductSingle);
//# sourceMappingURL=product-single.js.map


document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.getElementById('sticky-atc-bar');
  const mainAtc = document.querySelector('form[action="/cart/add"] button[type="submit"]');
  const stickyTrigger = document.querySelector('.js-sticky-atc-trigger');
  const quantityInput = document.querySelector('[name="quantity"]');
  const stickyQtyPreview = document.getElementById('sticky-qty-preview');

  if (!stickyBar || !mainAtc || !stickyTrigger) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        stickyBar.classList.remove('visible');
      } else {
        stickyBar.classList.add('visible');
      }
    },
    { threshold: 0 }
  );

  observer.observe(mainAtc);

  stickyTrigger.addEventListener('click', () => {
    if (quantityInput) {
      // just trigger main ATC — it uses current quantity automatically
      mainAtc.click();
    }
  });

  // Optional: live-update quantity preview in sticky bar
  if (quantityInput && stickyQtyPreview) {
    stickyQtyPreview.textContent = quantityInput.value;
    quantityInput.addEventListener('input', () => {
      stickyQtyPreview.textContent = quantityInput.value;
    });
  }
});